import {
    Alert,
    AlertTitle,
    Box,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Grid,
    Skeleton,
    Typography,
} from "@mui/material";
import { styles } from "../../style";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
// import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
// import TextToggle from "../../components/TextToggle";
import React, { useEffect } from "react";
import { format } from "date-fns";
import TextToggle from "../../components/TextToggle";

export const FeeRequestCard = ({ cItem, userDetails }) => {
    const requestNotesRef = React.useRef();
    const commentsRef = React.useRef();

    const coBrokerRef = React.useRef();
    const coBrokerProposalLanguageRef = React.useRef();

    const getImageURL = (profileImage) => {
        return profileImage ? profileImage : "";
    };
    const formatTimeWithZone = (dateToFormat) => {
        // console.log('TIME ZONE')
        // console.log(dateToFormat)
        let num = new Date().getTimezoneOffset();

        if (num < 0) {
            num = Math.abs(num);
            const hours = String(Math.floor(num / 60)).padStart(2, "0");
            const minutes = String(Math.floor(num % 60)).padStart(2, "0");
            let timeZone = `${hours}:${minutes}`;
            return format(new Date(dateToFormat + "T05:00:00+" + timeZone), "MMMM d, yyyy");
        }
        const hours = String(Math.floor(num / 60)).padStart(2, "0");
        const minutes = String(Math.floor(num % 60)).padStart(2, "0");
        let timeZone = `${hours}:${minutes}`;
        // console.log(dateToFormat + 'T05:00:00-' + timeZone)
        return format(new Date(dateToFormat + "T05:00:00-" + timeZone), "MMMM d, yyyy");
    };

    const getLocation = (cItem) => {
        let location = [];
        if (cItem.eventCity) {
            location.push(cItem.eventCity);
        }
        if (cItem.eventState) {
            location.push(cItem.eventState);
        }
        if (cItem.eventCountry) {
            location.push(cItem.eventCountry);
        }
        return location.join(", ");
    };

    // useEffect(() => {
    //     const updateHeights = () => {
    //         if (!requestNotesRef.current || !coBrokerRef.current) return;
    //         if (window.innerWidth < 600) return;

    //         const requestNoteHeight = requestNotesRef.current?.clientHeight || 0;
    //         const coBrokerHeight = coBrokerRef.current?.clientHeight || 0;

    //         const max = Math.max(requestNoteHeight, coBrokerHeight);

    //         requestNotesRef.current.style.height = `${max}px`;
    //         requestNotesRef.current.style.overflow = `auto`;

    //         coBrokerRef.current.style.height = `${max}px`;
    //         coBrokerRef.current.style.overflow = `auto`;
    //     };

    //     updateHeights(); // Run initially

    //     window.addEventListener("resize", updateHeights);
    //     return () => window.removeEventListener("resize", updateHeights);
    // }, []);

    const getEventTitle = (cItem) => {
        return `${cItem.speakerName} | ${cItem.feeType?.length ? cItem.feeType.join(", ") : getLocation(cItem)}`;
    };

    const getEventDate = (cItem) => {
        if (cItem.startDate === cItem.endDate) {
            return formatTimeWithZone(cItem.startDate);
        } else {
            if (cItem.startDate && cItem.endDate) {
                return `${formatTimeWithZone(cItem.startDate)} - ${formatTimeWithZone(cItem.endDate)}`;
            } else if (cItem.startDate) {
                return formatTimeWithZone(cItem.startDate);
            } else if (cItem.endDate) {
                return formatTimeWithZone(cItem.endDate);
            }
        }
    };

    return (
        <Card
            key={cItem.id}
            sx={{
                ...styles.card,
                mt: "15px",
                backgroundColor: "white",
            }}>
            <CardHeader
                sx={{
                    padding: {
                        sm: "16px 24px",
                        xs: "16px 16px",
                    },
                    // borderBottom: "1px solid #ededed",

                    "& .MuiCardHeader-action": {
                        display: "flex",

                        alignItems: "center",
                        justifyContent: "flex-end",

                        // flexDirection: "column",
                        margin: 0,
                        marginTop: "0.2rem",
                    },
                }}
                title={
                    <>
                        <Typography component={"h5"} variant="h5" color={"#101828"} marginTop={"2px"}>
                            {getEventTitle(cItem)}
                        </Typography>
                    </>
                }
                action={
                    <>
                        <Typography component={"p"} variant="body2" color={"gray.main"} fontWeight={600}>
                            Request Status
                        </Typography>

                        <Box
                            sx={{
                                // border: "1px solid #E0EAFF",
                                background:
                                    cItem.status === "Approved"
                                        ? "#ECFDF3"
                                        : cItem.status === "Declined"
                                        ? "#FFEEEB"
                                        : cItem.status === "In Progress"
                                        ? "#FFF1E7"
                                        : "#d9eeff",
                                color:
                                    cItem.status === "Approved"
                                        ? "#074D31"
                                        : cItem.status === "Declined"
                                        ? "#CB2F10"
                                        : cItem.status === "In Progress"
                                        ? "#DA6207"
                                        : "#3883d4",
                                borderRadius: "16px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "6px 12px",
                                fontSize: "12px",
                                lineHeight: "normal",
                                fontWeight: "500",
                                width: "fit-content",
                                marginLeft: "0.5rem",
                            }}>
                            {cItem.status}
                        </Box>
                    </>
                }></CardHeader>

            <Divider sx={{ borderColor: "#f4f4f5" }} />

            <CardContent
                sx={{
                    padding: {
                        sm: "16px 24px",
                        xs: "16px 16px",
                    },
                }}>
                {cItem.feeStatusReason === "Inactive" && cItem.status === "Approved" && (
                    <Alert severity="error" sx={{ mb: "1rem" }}>
                        This fee is no longer applicable. Please reach out to{" "}
                        {userDetails.contact?.accountOwnerName ? userDetails.contact?.accountOwnerName : "Admin"} for
                        more information.
                    </Alert>
                )}
                <Grid container spacing={2}>
                    {/* image part */}
                    <Grid item xs={12} sm={2} md={2.5} lg={1.8}>
                        <Box
                            width={"100%"}
                            height={"100%"}
                            display={"flex"}
                            justifyContent={"start"}
                            alignItems={"center"}
                            flexDirection={"column"}>
                            <>
                                {getImageURL(cItem.speakerImageURL) && (
                                    <Box
                                        component="img"
                                        sx={{
                                            objectFit: "cover",
                                            width: { xs: "100px", sm: "100px" },
                                            height: { xs: "100px", sm: "120px" },
                                            objectPosition: "top",
                                            borderRadius: "8px",
                                            marginBottom: "0.5rem",
                                        }}
                                        src={`${getImageURL(cItem.speakerImageURL)}`}></Box>
                                )}
                                {!getImageURL(cItem.speakerImageURL) && (
                                    <Skeleton
                                        variant="reactangle"
                                        sx={{
                                            width: { xs: "100px", sm: "100px" },
                                            height: { xs: "100px", sm: "120px" },
                                            borderRadius: "8px",
                                            // marginLeft: "0.5rem",
                                        }}
                                    />
                                )}
                            </>

                            <Typography
                                component={"div"}
                                variant="subtitle1"
                                fontWeight={600}
                                color={"#101828"}
                                fontSize={"18px"}
                                textAlign={"center"}>
                                {cItem.speakerName}
                            </Typography>
                        </Box>
                    </Grid>

                    {/* vertical devider */}
                    <Grid item xs={12} sm={1} md={0.25} lg={0.25}>
                        <Divider
                            orientation="vertical"
                            sx={{
                                borderRightWidth: {
                                    xs: "0",
                                    sm: "thin",
                                },
                                borderTopWidth: {
                                    xs: "thin",
                                    sm: "0",
                                },
                            }}
                        />
                    </Grid>

                    {/* second part */}
                    <Grid item xs={12} sm={9} md={6.5} lg={5.2}>
                        <Grid container spacing={4} rowSpacing={2}>
                            {cItem.clientName && (
                                <Grid item xs={12}>
                                    <Typography component={"p"} variant="body2" color={"gray.main"} fontWeight={600}>
                                        Client / Bureau Name
                                    </Typography>
                                    <Typography
                                        component={"p"}
                                        variant="body2"
                                        marginTop={"0.2rem"}
                                        color={"#475467"}
                                        fontWeight={500}
                                        fontSize={"14px"}
                                        display={"flex"}
                                        alignItems={"center"}
                                        lineHeight={1}>
                                        {cItem.clientName}
                                    </Typography>
                                </Grid>
                            )}

                            <Grid item xs={6}>
                                <Typography component={"p"} variant="body2" color={"gray.main"} fontWeight={600}>
                                    Event Date
                                </Typography>
                                <Typography
                                    component={"p"}
                                    variant="body2"
                                    marginTop={"0.25rem"}
                                    color={"#475467"}
                                    fontWeight={500}
                                    fontSize={"14px"}
                                    display={"flex"}
                                    alignItems={"center"}
                                    lineHeight="1.5rem">
                                    <CalendarMonthOutlinedIcon
                                        color="brand"
                                        fontSize="small"
                                        sx={{ marginRight: "0.25rem" }}
                                    />{" "}
                                    <span
                                        title={cItem.startDate ? getEventDate(cItem) : cItem.eventDateTBD ? "TDB" : ""}
                                        style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                        {cItem.startDate ? getEventDate(cItem) : cItem.eventDateTBD ? "TDB" : ""}
                                    </span>
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography component={"p"} variant="body2" color={"gray.main"} fontWeight={600}>
                                    Location
                                </Typography>
                                <Typography
                                    component={"p"}
                                    variant="body2"
                                    marginTop={"0.25rem"}
                                    color={"#475467"}
                                    fontWeight={500}
                                    fontSize={"14px"}
                                    display={"flex"}
                                    alignItems={"center"}
                                    lineHeight={1}>
                                    <LocationOnOutlinedIcon
                                        color="brand"
                                        fontSize="small"
                                        sx={{ marginRight: "0.25rem" }}
                                    />{" "}
                                    <span
                                        title={getLocation(cItem)}
                                        style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                        {getLocation(cItem)}
                                    </span>
                                </Typography>
                            </Grid>
                        </Grid>
                        {cItem.requestNotes && (
                            <Box
                                sx={{
                                    padding: "10px 14px",
                                    borderRadius: "10px",
                                    background: "#FAFBFC",

                                    marginTop: "1rem",
                                }}>
                                <Typography component={"p"} variant="body2" color={"gray.main"} fontWeight={600}>
                                    Request Details
                                </Typography>
                                <Typography
                                    ref={requestNotesRef}
                                    component={"p"}
                                    variant="body2"
                                    fontSize={"12px"}
                                    fontWeight={400}
                                    color={"#101828"}
                                    marginTop={"5px"}>
                                    <TextToggle
                                        parentRef={requestNotesRef}
                                        text={cItem.requestNotes}
                                        maxLines={5}></TextToggle>
                                </Typography>
                            </Box>
                        )}
                        {cItem.comments && (
                            <Box
                                sx={{
                                    padding: "10px 14px",
                                    borderRadius: "10px",
                                    background: "#FAFBFC",

                                    marginTop: "1rem",
                                }}>
                                <Typography component={"p"} variant="body2" color={"gray.main"} fontWeight={600}>
                                    Comments
                                </Typography>
                                <Typography
                                    ref={commentsRef}
                                    component={"p"}
                                    variant="body2"
                                    fontSize={"12px"}
                                    fontWeight={400}
                                    color={"#101828"}
                                    marginTop={"5px"}>
                                    <TextToggle parentRef={commentsRef} text={cItem.comments} maxLines={5}></TextToggle>
                                </Typography>
                            </Box>
                        )}
                    </Grid>

                    {/* vertical devider */}
                    <Grid item xs={12} sm={0} md={0.25} lg={0.25}>
                        <Divider
                            orientation="vertical"
                            sx={{
                                borderRightWidth: {
                                    xs: "0",
                                    sm: "thin",
                                },
                                borderTopWidth: {
                                    xs: "thin",
                                    sm: "0",
                                },
                            }}
                        />
                    </Grid>

                    {/* third part */}
                    <Grid item xs={12} sm={12} md={2.5} lg={4.5}>
                        <Box
                            display={"flex"}
                            flexDirection={"column"}
                            justifyContent={"start"}
                            width={"100%"}
                            height={"100%"}>
                            <Box
                                sx={{
                                    padding: "22px 16px",
                                    borderRadius: "8px",
                                    border: "1px solid #EEF4FF",
                                    background: "#F5F8FF",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    flexDirection: "column",

                                    // ...(!cItem.coBrokerLanguage && {
                                    //     height: "100%",
                                    // }),
                                }}>
                                <Typography component={"p"} fontSize={"14px"} color={"#70707B"} fontWeight={500}>
                                    Speaker Fee
                                </Typography>
                                <Typography component={"p"} fontSize={"22px"} fontWeight={700} color={"#51525C"}>
                                    {cItem.feeAmount
                                        ? new Intl.NumberFormat("en-US", {
                                              style: "currency",
                                              currency: "USD",
                                              maximumFractionDigits: 2,
                                          }).format(cItem.feeAmount)
                                        : "PENDING"}
                                </Typography>
                                

                                {cItem.feeClientExtent && (
                                    <Typography
                                        component={"p"}
                                        fontSize={"12px"}
                                        fontWeight={500}
                                        color={"#51525C"}
                                        textAlign={"center"}>
                                        plus&nbsp;
                                        {cItem.feeClientExtent}
                                    </Typography>
                                )}

{cItem.availability && (
                                    <Box
                                        sx={{
                                            // border: "1px solid #E0EAFF",
                                            background:
                                                cItem.availability === "Available"
                                                    ? "#ECFDF3"
                                                    : cItem.availability === "Not Available"
                                                    ? "#FFEEEB"
                                                    : "#FFF1E7",
                                            color:
                                                cItem.availability === "Available"
                                                    ? "#074D31"
                                                    : cItem.availability === "Not Available"
                                                    ? "#CB2F10"
                                                    : "#3883d4",
                                            borderRadius: "16px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            padding: "6px 12px",
                                            fontSize: "12px",
                                            lineHeight: "normal",
                                            fontWeight: "500",
                                            width: "fit-content",
                                            marginLeft: "0.5rem",
                                            marginBottom: "0.5rem",
                                            marginTop: "0.5rem",
                                        }}>
                                        {cItem.availability === "Available"
                                            ? "Speaker is available on the requested dates."
                                            : "Speaker is not available on the requested dates."}
                                    </Box>
                                )}
                            </Box>

                            {cItem.coBrokerLanguage && (
                                <Box
                                    sx={{
                                        padding: "10px 14px",
                                        borderRadius: "10px",
                                        background: "#FAFBFC",

                                        marginTop: "1rem",
                                    }}>
                                    <Typography component={"p"} variant="body2" color={"gray.main"} fontWeight={600}>
                                        Co-Broker Notes
                                    </Typography>
                                    <Typography
                                        ref={coBrokerRef}
                                        component={"p"}
                                        variant="body2"
                                        fontSize={"12px"}
                                        fontWeight={400}
                                        color={"#101828"}
                                        marginTop={"5px"}>
                                        <TextToggle
                                            parentRef={coBrokerRef}
                                            text={cItem.coBrokerLanguage}
                                            maxLines={5}></TextToggle>
                                    </Typography>
                                </Box>
                            )}
                            {cItem.coBrokerCommissionStatus && cItem.coBrokerProposalLanguage && (
                                <Box sx={{ marginTop: "1rem" }}>
                                    <Alert icon={false} severity="info" sx={{ mb: "10px" }}>
                                        <AlertTitle sx={{ fontSize: ".8rem", fontWeight: "600" }}>
                                            Co-Broker Information
                                        </AlertTitle>
                                        <Typography
                                            ref={coBrokerProposalLanguageRef}
                                            component={"p"}
                                            variant="body2"
                                            fontSize={"12px"}
                                            fontWeight={400}
                                            color={"#101828"}
                                            marginTop={"5px"}>
                                            <TextToggle
                                                parentRef={coBrokerProposalLanguageRef}
                                                text={cItem.coBrokerProposalLanguage}
                                                maxLines={5}></TextToggle>
                                        </Typography>
                                    </Alert>
                                </Box>
                            )}

                            {/* Commenting comment box */}
                            {/* <Box
                                sx={{
                                    borderRadius: "8px",
                                    border: "1px solid #D0D5DD",
                                    background: "#fff",
                                    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",

                                    padding: "8px 14px",

                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",

                                    marginTop: "1rem",
                                }}
                            >
                                <ChatOutlinedIcon color="brand" fontSize="small" sx={{ marginRight: "0.5rem" }} />
                                Comments
                                <Box
                                    component={"div"}
                                    sx={{
                                        borderRadius: "4px",
                                        background: "#F97316",
                                        padding: "0px 4px",
                                        fontSize: "12px",
                                        fontWeight: 600,
                                        color: "#fff",
                                        marginLeft: "0.5rem",
                                    }}
                                >
                                    {cItem.comments}
                                </Box>
                            </Box> */}
                        </Box>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};
